import Icon from "components/icon";
import styled from "@emotion/styled";

export const StyledDeleteIcon = styled(Icon)`
  cursor: pointer;
  margin-left: 0.5rem;
  margin-top: 2.235rem;
`;
